export default __webpack_public_path__ + "static/CopernicusWeb-Bold-9e695f2090181c84f98eeed56911ede1.woff";